import React from 'react';
import TabsSection from '../../components/TabSection';

const Solutions2 = () => {
  const cardData = [
    {
      title: "ERP",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359425/image-23_cwkvtm.png",
    },
    {
      title: "OPPORTUNITIES",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359425/image-24_po2psa.png",
    },
    {
      title: "RESOURCES",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359392/image-6_yhlefd.png",
    },
  ];

  return (
    <div className="bg-white">
      <div className="md:px-28 px-4 md:pt-3 pt-2 md:pb-14 pb-4">
        <h1 className="text-[14px] md:text-[36px] font-bold md:mt-6 mt-2 md:mb-6 text-[#152C24]">INPUTS SUPPLIERS</h1>
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745281940/image-8_u6kbyr.png"
          alt="Securing Agriculture in Namibia"
          className="w-full md:h-[480px] object-cover md:rounded-lg rounded-md transition-opacity duration-500"
        />

        <section className="flex-1 mt-10">
          <h2 className="text-[32px] font-bold text-[#152C24] mb-6">
            <strong className="font-bold text-black">INPUTS SUPPLIER: </strong> How can they benefit?
          </h2>
          <h2 className="font-bold text-[32px] text-black mb-6">
            An Inputs Supplier (someone who sells seeds, fertilizers, pesticides, tools, or agro-equipment) can gain huge advantages by using the Farmnet App to reach more farmers and grow their agribusiness.
          </h2>
          <div className="space-y-10 text-[18px] md:text-[32px]">
            {[
              { title: "Direct Access to a Wide Farmer Network", content: [
                "Connect with thousands of registered farmers and cooperatives on the platform.",
                "Reach customers in remote rural areas without needing physical shops everywhere."
              ] },
              { title: "Digital Marketplace for Inputs", content: [
                "List your products (seeds, fertilizers, etc.) on the app so farmers can browse and place orders directly.",
                "Grow your sales with online visibility and 24/7 access to your input store."
              ] },
              { title: "Bulk Orders & Demand Forecasting", content: [
                "Receive group orders from farmer groups or cooperatives, increasing volume and reducing logistics costs.",
                "Use platform data to forecast demand by season, crop, and location."
              ] },
              { title: "Trusted Supplier Profile", content: [
                "Build brand visibility and trust by having a verified supplier profile with ratings and reviews.",
                "Stand out from informal or counterfeit competitors."
              ] },
              { title: "Simplified Distribution", content: [
                "Coordinate with local transporters, community agents, or collection centers through Farmnet.",
                "Optimize your last-mile delivery to reach more farmers faster."
              ] },
              { title: "Real-Time Feedback from Farmers", content: [
                "Receive feedback on product performance, quality, and pricing.",
                "Use insights to improve products, customer service, and loyalty."
              ] },
              { title: "Promote Discounts & Seasonal Offers", content: [
                "Run digital promotions, bundles, or loyalty programs directly through the app.",
                "Attract more buyers during planting or peak seasons."
              ] },
              { title: "Sales & Inventory Tracking", content: [
                "Digitally manage orders, payments, and stock—no more manual paperwork.",
                "Access transaction records for easier planning and financial reporting."
              ] },
              { title: "Collaborate with Financiers & Development Partners", content: [
                "Partner with credit providers to offer inputs on loan (Buy Now, Pay Later) through the app.",
                "Join input subsidy programs or donor-funded input support projects."
              ] },
              { title: "Business Growth & Market Expansion", content: [
                "Expand into new regions and underserved markets without high overhead.",
                "Build strong relationships with farmers and cooperatives through continuous digital engagement."
              ] }
            ].map((section, index) => (
              <div key={index}>
                <strong>{index + 1}. {section.title}</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  {section.content.map((text, idx) => (
                    <li key={idx}>{text}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Solutions2;
